import { useAccountManagementStore } from "@/pinia/useAccountManagementStore";
import { storeToRefs } from "pinia";
import { ref } from "vue";

export default function usePolling() {
  const polling = ref<NodeJS.Timeout>();
  const maxTime = 60000; // 1 min
  let currentInterval = 1000;
  const { getMemberStatus } = storeToRefs(useAccountManagementStore());

  const executePolling = (callback: Function, timer: number = 60000) => {
    if (timer == 0) {
      clearTimeout(polling.value);
    } else {
      polling.value = setTimeout(async () => {
        await callback();
        executePolling(callback, timer);
      }, timer);
    }
  };

  const getUpdatedStatus = (callback: Function) => {
    polling.value = setTimeout(
      async () => {
        // Check if we've reached the maximum time
        await callback();
        if (getMemberStatus.value || currentInterval > maxTime) {
          clearTimeout(polling.value);
        } else {
          currentInterval += 3000;
          getUpdatedStatus(callback); // Schedule the next call
        }
      },
      currentInterval == 1000 ? 1000 : 3000,
    );
  };

  const getUpdatedDetailPage = (callback: Function) => {
    polling.value = setTimeout(async () => {
      await callback();
      if (currentInterval < maxTime) {
        currentInterval *= 2; // Schedule the next call
      } else {
        currentInterval = 60000;
      }
      getUpdatedDetailPage(callback);
    }, currentInterval);
  };

  const resetPolling = () => {
    clearTimeout(polling.value);
  };

  return {
    resetPolling,
    executePolling,
    getUpdatedStatus,
    getUpdatedDetailPage,
  };
}
